// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DynamicSearchLabel_wrapper__3dtKj"};